import React from 'react'
import TNLogo from '../../Constant/Icons/TamilNadu_Logo.png';
import './Footer.css'

export default function header({ children }) {
    return (
        <div className="header">
            <div>
                <a href='http://localhost:3000'>
                    <img alt='TN' src={TNLogo} width={50} height={50}></img>
                </a>
            </div>
            <div className='header-content'>
                <h3>GOVERNMENT OF TAMILNADU</h3>
                <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2025</h4>
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}
